import { Link } from "react-router-dom";
import { useTranslations } from "@/lib/useTranslations";

import {
  adminNavItems,
  isAdminNavActive,
} from "@/components/ui/admin/nav-items";
import { useAuth } from "@/lib/auth";

interface TopNavProps {
  pathname: string;
  orientation?: "horizontal" | "vertical";
  onNavigate?: () => void;
}

export function TopNav({
  pathname,
  orientation = "horizontal",
  onNavigate,
}: TopNavProps) {
  const t = useTranslations("nav");
  const tCommon = useTranslations("common");
  const { isAdmin } = useAuth();
  const isVertical = orientation === "vertical";
  const visibleNavItems = adminNavItems.filter(
    (item) => !item.adminOnly || isAdmin,
  );

  return (
    <nav
      aria-label={tCommon("adminNav")}
      className={isVertical ? "px-3 py-3" : "hidden lg:block"}
    >
      <ul
        className={
          isVertical
            ? "space-y-1"
            : "flex items-center gap-1 overflow-x-auto"
        }
      >
        {visibleNavItems.map((item) => {
          const isActive = isAdminNavActive(pathname, item.href);

          return (
            <li key={item.href} className={isVertical ? undefined : "shrink-0"}>
              <Link
                to={item.href}
                onClick={onNavigate}
                className={`block text-sm transition-colors ${
                  isVertical
                    ? "border-l-2 px-3 py-2"
                    : "border-b-2 px-3 py-3"
                } ${
                  isActive
                    ? isVertical
                      ? "border-whart-dark bg-neutral-100 font-medium text-whart-text"
                      : "border-whart-dark font-medium text-whart-text"
                    : isVertical
                      ? "border-transparent text-neutral-600 hover:bg-neutral-50 hover:text-whart-text"
                      : "border-transparent text-neutral-600 hover:border-black/10 hover:text-whart-text"
                }`}
              >
                {t(item.labelKey)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
